import { Box, Button, Grid } from '@mui/material';
import { Event } from 'modules/events/types/eventsTypes';
import React, { FC } from 'react';
import { EventsProduct } from '../EventsProduct/EventsProduct';

type EventPreviewProps = {
  event?: Event;
  onBack: () => void;
  onSubmit: () => void;
};

export const EventPreview: FC<EventPreviewProps> = ({ event, onBack, onSubmit }) => {
  return (
    <Box px={8} py={4}>
      <EventsProduct data={event as Event} preview />
      <Grid container justifyContent="flex-end">
        <Button onClick={onBack}>Back</Button>
        <Button variant="contained" color="primary" onClick={onSubmit}>
          Save event
        </Button>
      </Grid>
    </Box>
  );
};
